import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyAgentActionReviewDetailPage = lazyWithRetry(
  () => import("./AgentActionReviewDetailPage"),
);

const AgentActionReviewDetailPage = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyAgentActionReviewDetailPage {...props} />;

export default AgentActionReviewDetailPage;
